import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { localStoragevarNames } from '../utilities/local-storage-utils';
import { Observable } from 'rxjs';
import { AiAgentResponse } from '../models/responses/ai-agent-response';
import { CalComIntegrationResponse } from '../models/responses/calcom-integration-response';
import { UpdateAiAgentRequest } from '../models/requests/update-ai-agent-request';
import { GhlCalendarItemResponse } from '../models/responses/ghl-calendar-item-response';
import { UpdateGHLIntegrationRequest } from '../models/requests/update-ghl-integration-request';
import { GhlCalendarResponse } from '../models/responses/ghl-calendar-response';

@Injectable({
  providedIn: 'root'
})
export class AiAgentService {

  constructor(private httpClient: HttpClient) { }

  createAiAgent(name: string, userId: number): Observable<AiAgentResponse> {
    return this.httpClient.post<AiAgentResponse>(`${environment.aiAgentUrl}/create`, { name, userId, phoneNumber: '', chosenVoiceId: '' });
  }

  createIntroMessage(agentId:number,formData:FormData){
    return this.httpClient.post<AiAgentResponse>(`${environment.aiAgentUrl}/uploadIntroMessage/${agentId}`, formData);
  }
  deleteIntroMessage(agentId:number){
    return this.httpClient.delete<AiAgentResponse>(`${environment.aiAgentUrl}/deleteIntroMessage/${agentId}`);
  }

  addCalComIntegration(integration: CalComIntegrationResponse): Observable<CalComIntegrationResponse> {
    return this.httpClient.post<CalComIntegrationResponse>(`${environment.aiAgentUrl}/integration/calcom`, { integration });
  }

  removeCalComIntegration(id: number) {
    return this.httpClient.delete(`${environment.aiAgentUrl}/integration/calcom/${id}`);
  }

  updateAiAgent(updateAiAgentRequest: UpdateAiAgentRequest): Observable<AiAgentResponse> {
    return this.httpClient.put<AiAgentResponse>(`${environment.aiAgentUrl}/update`, updateAiAgentRequest);
  }

  fetchLoggedUserAiAgents(): Observable<AiAgentResponse[]> {
    return this.httpClient.get<AiAgentResponse[]>(`${environment.aiAgentUrl}/all`);
  }

  fetchSubaccountAiAgents(userId: number): Observable<AiAgentResponse[]> {
    return this.httpClient.get<AiAgentResponse[]>(`${environment.aiAgentUrl}/subaccount/fetch/all/${userId}`);
  }

  fetchAiAgentById(id: number): Observable<AiAgentResponse> {
    return this.httpClient.get<AiAgentResponse>(`${environment.aiAgentUrl}/fetch/${id}`);
  }

  fetchGHLCalendars(id:number):Observable<GhlCalendarResponse>{
    return this.httpClient.get<GhlCalendarResponse>(`${environment.aiAgentUrl}/leadconnector/calendars/${id}`);
  }
  updateGHLCalendar(request:UpdateGHLIntegrationRequest):Observable<GhlCalendarItemResponse>{
    return this.httpClient.put<GhlCalendarItemResponse>(`${environment.aiAgentUrl}/leadconnector/integration`,request);
  }
  deleteGHLCalendar(id:number):Observable<GhlCalendarItemResponse>{
    return this.httpClient.delete<GhlCalendarItemResponse>(`${environment.aiAgentUrl}/leadconnector/integration/${id}`);
  }
}
